<template>
    <Layout :content-class="'content--centered'">
        <PodcastEdit />
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import PodcastEdit from '../../components/PodcastEdit/PodcastEdit';

export default {
    name: 'CreatePodcastPage',
    components: {
        Layout,
        PodcastEdit
    }
};
</script>
